<template>
  <layout>
    <h2>{{ $t('pages.become_prescriber.title') }}</h2>
    <image-block
      :image-url="image.imageUrl"
      :title="image.title"
      :text="image.text"
    />
    <form-type
      :parts="parts"
      :schema="becomePrescriber"
      :post-uri="postUri"
      :success_route="{ name: 'home' }"
      :config="{ headers: { 'Content-Language': $translation.getLocale() } }"
      form="become_prescriber"
    />
    <p class="spam-message">{{ $t('pages.become_prescriber.spam_alert') }}</p>
  </layout>
</template>

<script>
  import Layout from '@/views/Default/Layout';
  import FormType from '@/components/FormType';
  import ImageBlock from '@/components/ImageBlock';

  export default {
    name: 'BecomePrescriber',
    components: {
      Layout,
      FormType,
      ImageBlock,
    },
    data() {
      return {
        postUri: 'api/public/become_prescriber/',
        image: {
          imageUrl: '../../../static/img/bg2.jpg',
          title: this.$t('pages.become_prescriber.image_block.title'),
          text: this.$t('pages.become_prescriber.image_block.text'),
        },
        parts: [{
          formType: 'input',
          name: 'name',
          type: 'text',
          placeholder: 'form.name',
          required: true,
          isActive: true,
          label: 'form.name',
        }, {
          formType: 'input',
          name: 'email',
          type: 'email',
          placeholder: 'form.email',
          required: true,
          isActive: true,
          label: 'form.email',
        }, {
          formType: 'input',
          name: 'phone',
          type: 'tel',
          placeholder: 'form.phone',
          required: false,
          isActive: true,
          label: 'form.phone',
        }, {
          formType: 'input',
          name: 'job',
          type: 'text',
          placeholder: 'form.profession',
          required: true,
          isActive: true,
          label: 'form.profession',
        }],
        becomePrescriber: {
          name: '',
          email: '',
          job: '',
          phone: '',
        },
      };
    },
  };
</script>

<style lang="scss" scoped>
  @import '~@/scss/vars';

  p.spam-message {
    margin-top: 15px;
    font-size: 0.9em;
  }
</style>



// WEBPACK FOOTER //
// src/views/Default/BecomePrescriber.vue